export function projectsFlexText () {
    function bty_projectsFlexText() {
        let img_media = document.body.querySelectorAll('.has-media-on-left img');
        let width;
        let index = (img_media.length - 1);
        while (img_media[index].complete === true) {
            if (img_media[index].offsetWidth !== 0) {
                width = img_media[index].offsetWidth;
                bty_projectsFlexExe(width);
                break;
            } else {
                projectsFlexText();
            }
        }

    }

    function bty_projectsFlexExe (width) {
        document.querySelector('.template-projects__wrapper__bottom').parentElement.style.zIndex = '1';
        document.querySelector('.template-projects__wrapper__bottom').parentElement.style.position = 'relative';
        document.querySelector('.template-projects__wrapper__bottom').parentElement.style.width = width + 'px';
        document.querySelector('.template-projects__wrapper__bottom-container').style.width = width + 'px';
    }

    // window.onload = bty_rotateAdjuster;
    document.addEventListener('DOMContentLoaded', function () {
        bty_projectsFlexText();

        window.addEventListener('resize', function () {
            bty_projectsFlexText();
        });
    });
};
